import PlotWrapper from "../components/PlotWrapper";
import { HISTOGRAM_CONFIG, HISTOGRAM_LAYOUT } from "../constants";
import React, { useLayoutEffect } from "react";
import { TRootState } from "../store/create-store";
import { useDispatch, useSelector } from "react-redux";
import {
  calculateHistogramDimensions,
  calculateScatterPlotDimensions,
} from "../utils/window-utils";
import useWindowResize from "../hooks/useWindowResize";
import debounce from "lodash.debounce";
import { PlotRelayoutEvent } from "plotly.js";
import { rootActions } from "../reducers/root.slice";
import styles from "./Histogram.module.css";
import { selectRightPanelState, selectRootState } from "../selectors";

const calculateDimensions = (rightPanelVisible: boolean) =>
  calculateHistogramDimensions(
    calculateScatterPlotDimensions(rightPanelVisible).width
  );

const Histogram = () => {
  const dispatch = useDispatch();
  const { histogramData, rightPanelVisible, histogramLayout } =
    useSelector(selectHistogram);

  function handleResize() {
    const dimensions = calculateDimensions(rightPanelVisible);

    dispatch(
      rootActions.setHistogramLayout({
        ...HISTOGRAM_LAYOUT,
        ...dimensions,
      })
    );
  }
  const debouncedHandleResize = debounce(handleResize, 100);
  useWindowResize(debouncedHandleResize);
  useLayoutEffect(debouncedHandleResize, [rightPanelVisible]);

  const onRelayout = (event: PlotRelayoutEvent) => {
    console.info("onRelayout", event);

    if (event["xaxis.autorange"] || event["yaxis.autorange"]) {
      dispatch(rootActions.generateGraph());
      return;
    }

    const min = event["xaxis.range[0]"];
    const max = event["xaxis.range[1]"];

    if (min && max) {
      dispatch(rootActions.generateGraph({ range: [min, max] }));
    }
  };

  return (
    <div className={styles.histogramWrapper}>
      <PlotWrapper
        key="histogram"
        data={histogramData}
        layout={histogramLayout}
        config={HISTOGRAM_CONFIG}
        onClick={() => {}}
        onRelayout={onRelayout}
      />
    </div>
  );
};

const selectHistogram = (state: TRootState) => {
  const { histogramData, histogramLayout } = selectRootState(state);

  return {
    histogramData,
    rightPanelVisible: selectRightPanelState(state).visible,
    histogramLayout,
  };
};

export default Histogram;
